export const environment = {
	production: true,
	version: '0.0.0',
	oktaIssuer: process.env.OKTA_ISSUER,
	oktaClientId: process.env.OKTA_CLIENT_ID
};
